exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#kirmizi{background-color:#ef1c1c}#kirmizi,#turuncu{border-radius:15px 50px;text-align:center;font-size:25px}#turuncu{background-color:#f90}#sari{background-color:#f4ff2d}#sari,#yesil{border-radius:15px 50px;text-align:center;font-size:25px}#yesil{background-color:#76f118}#mavi{border-radius:15px 50px;background-color:#19c6f1;text-align:center;font-size:25px}#pid1:hover,#pid2:hover,#pid3:hover,#pid4:hover{border-radius:15px 50px;background-color:#63ca92;text-align:center;font-size:25px}.col-md-3{width:100%}.rowHomepage{display:flex;flex-wrap:wrap;justify-content:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d91adc30","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ComplateSaha.vue
// module id = 254
// module chunks = 0